import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-incidents-container',
  templateUrl: './incidents-container.component.html',
  styleUrls: ['./incidents-container.component.scss']
})
export class IncidentsContainerComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
